import React from "react";
import { useInitializeCustomBranding } from "@hooks/customBranding/useInitializeCustomBranding";
import { AuthStatus } from "@constants/authentication";
import { useNavigateStore } from "@stepHooks/useNavigateStore";
import { StepId } from "@constants/navigation";
import { ErrorState } from "@constants/error";
import ErrorAlert from "@components/general/ErrorAlert";
import { useTranslation } from "react-i18next";
import { useTrackPageRefreshEvent } from "./useTrackPageRefreshEvent";
import { useCheckAuthErrorAlertOnInitStep } from "./useCheckAuthErrorAlertOnInitStep";
import { useCheckUserAuthentication } from "./useCheckUserAuthentication";
import { StepFlowGate } from "@stepComponents/Navigator/StepFlowGate";
import { useProcessUrlParams } from "@stepHooks/useProcessUrlParams";
import { useSetBackgroundStyle } from "./useSetBackgroundStyle";

export const InitStep = () => {
    const { t } = useTranslation();
    const navigateToSignInStep = useNavigateStore(
        (store) => store.navigateToSignInStep
    );

    useTrackPageRefreshEvent();

    const isUrlParamsProcessed = useProcessUrlParams();
    const hasAuthError = useCheckAuthErrorAlertOnInitStep();
    const isCustomBrandingResourceReady = useInitializeCustomBranding();
    const authStatus = useCheckUserAuthentication();

    useSetBackgroundStyle(isUrlParamsProcessed);

    const isInitCompleted =
        isUrlParamsProcessed &&
        isCustomBrandingResourceReady &&
        authStatus !== AuthStatus.LOADING;

    // TODO [LOWA-30534] From: https://tiny.amazon.com/ejfk5dzn
    if (isInitCompleted && hasAuthError) {
        return (
            <ErrorAlert
                type={ErrorState.INFO}
                header={t("login.errorAlert.unauthorized.header")}
                message={t("login.errorAlert.unauthorized.message")}
                onDismissErrorAlert={navigateToSignInStep}
            />
        );
    }

    return (
        <StepFlowGate
            isCompleted={isInitCompleted}
            completedStepId={StepId.INIT}
        />
    );
};
